import { LOCATION_CHANGE } from 'connected-react-router'

const initialState = {
  mobile_filter_panel_open: false,
  mobile_booking_enquiry_form_show: false,
  previousLocation: '',
  currentLocation: '',
  visitedStoryOrListing: false,
}

export default (state = initialState, action) => {
  switch (action.type) {
    case 'SET_LISTINGS_MOBILE_FILTER_VIEW_STATE':
      return {
        ...state,
        mobile_filter_panel_open: action.payload,
      }

    case 'SET_LISTING_MOBILE_BOOKING_ENQUIRY_FORM_VIEW_STATE':
      return {
        ...state,
        mobile_booking_enquiry_form_show: action.payload,
      }

    case LOCATION_CHANGE: {
      const { location } = action.payload
      return {
        ...state,
        previousLocation: state.currentLocation,
        currentLocation: `${location.pathname}${location.search}`,
      }
    }

    default:
      return state
  }
}
